import { ContentBlock, Hint, MapsConfig } from '.'

export enum ZoneTypeEnum {
  Case = 'case',
  Brief = 'brief',
  // Investigation = 'investigation',
  // Evidence = 'evidence',
  // Anatomy = 'anatomy',
}

export enum ZoneStatus {
  Enabled = 'enabled',
  Hidden = 'hidden',
  Disabled = 'disabled',
  // Active = 'active', TODO: when user has an active zone
}

export type ZoneType = `${ZoneTypeEnum}`
// or: keyof typeof ZoneTypeEnum if you use keys

export interface ZoneTheme {
  grayscaleImages?: boolean
}

export interface DetectedZone {
  id: string
  type: ZoneType
  boundingBox: {
    north: number
    south: number
    east: number
    west: number
  }
  version?: number
}

export interface Zone {
  id: string
  name: string
  subTitle?: string
  // phasing out:
  type?: ZoneType
  boundingBox?: {
    north: number
    south: number
    east: number
    west: number
  }
  version?: number
  status: ZoneStatus
  advert?: ContentBlock
  theme?: ZoneTheme
}

export interface CaseZoneSettings {
  hideName?: boolean
  hideItems?: boolean
  hideMenuBanner?: boolean
  caseComplete?: {
    hideMap?: boolean
  }
}

export interface CaseZone extends Zone {
  subTitle?: string
  mapsConfig?: MapsConfig
  intro?: ContentBlock & {
    action?: string
  }
  profileSettings?: {
    title: string
    remaingRequiredText: string
  }
  hints?: Hint[]
  settings: CaseZoneSettings
}

export interface BriefZone extends Zone {
  type: ZoneTypeEnum.Brief
  summary: string
}

export type ZoneDetails = CaseZone | BriefZone
